import VueRouter from 'vue-router';


import Dashboard from './views/Dashboard'
import DashboardCardEdit from './views/DashboardCardEdit'
import EventCardEdit from './views/EventCardEdit'
import DDSCardEdit from './views/DDSCardEdit'
import DDS from './views/DDS'

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/kpi/:uuid',
            name: 'DashboardCardEdit',
            component: DashboardCardEdit,
            props: true
        },
        {
            path: '/event/:uuid',
            name: 'EventCardEdit',
            component: EventCardEdit,
            props: true
        },
        {
            path: '/dds/:uuid',
            name: 'DDSCardEdit',
            component: DDSCardEdit,
            props: true
        },
        {
            path: '/dds',
            name: 'DDS',
            component: DDS
        }
    ]
});

export default router;
